import React from "react"
import { CanadaIcon } from "./Icons";
import Cookies from "js-cookie";
import moment from "moment";
import { Tooltip } from "antd";

// Brought colours over from store-site
export const successColor = "#4f9818"; // green
export const warningColor = "#E77E21"; // orage
export const disabledColor = "#999999"; // grey
export const futureColor = "#189285"; // teal
export const bestsellerColor = "#F12A46"; // red
export const peerColor = "#A52A2A"; // burgandy
export const favColor = "#ffcf17" // yellow
export const highlightColor = "#49b7e0" // lightBlue
export const returnedColor = "#9932cc" // lightBlue



export const getColor = (_id, _template, _default = false) => {
  // check to see if id exists at all
  if (_template.hasOwnProperty("colours")) {
    _id = (_template.colours.find(item => item.id === _id) || _template.gradients.find(item => item.id === _id)) ? _id : 0;
  }
  // id of zero means no colour
  if (_id === 0) {
    return (_default) ? _default : "inherit";
  }

  let _f;
  if (_id % 2) {
    // colour
    _f = _template.colours.find(item => item.id === _id);
    return (_f) ? _f.style : "rgba(0, 0, 0, 1)";
  } else {
    // gradient
    _f = _template.gradients.find(item => item.id === _id);
    return (_f) ? _f.style : "rgba(0, 0, 0, 1)";
  }

}

export const getFontFamily = (font = 1, _template, loop = false) => {

  if (!_template.hasOwnProperty("fonts")) {
    return 'Default';
  }

  let _f = _template.fonts.find(item => item.id === font);
  if (_f) {
    return _f.name;
  } else {
    if (_template.base_font && !loop) {
      return getFontFamily(_template.base_font, _template, true);
    } else {
      return 'Default';
    }
  }
}

export const getTitleImagePath = (eisbn, cover_image_cache = 0, cover_image_key = 0, size = "large") => {
  if (eisbn) {
    const path = (size === "medium") ? "n" : (size === "small") ? "slider_23.php" : "m";
    const baseUrl = (cover_image_cache) ? `https://cdn1.bookmanager.com/i/${path}?b=` : `https://bookmanager.com/i/${path}?b=`;
    return (baseUrl + eisbn + (cover_image_cache ? `&cb=${cover_image_cache}` : "") + (cover_image_key ? `&b2b=${cover_image_key}` : ""));
  } else {
    return "";
  }

};

export const getISBNCount = (_str) => {
  // Regular expression to match ISBNs
  const isbnRegex = /(?:ISBN(?:: ?| ))?((?:97[89])?\d{9}[\dx])/gi;
  // Use the regular expression to search the string and get all matches
  const matches = _str.match(isbnRegex);
  // If there are no matches, return 0
  if (!matches) {
    return 0;
  }
  // Return the length of the matches array
  return matches.length;
}

export const prettyTime = (_str) => {
  const time = moment(_str, 'HH:mm:ss')
  if (time.isValid()) {
    return time.format('h:mm A');
  }
  else {
    return "";
  }
};

export const parseAuthors = (_authors) => {
  if (!_authors) { return "" }
  return _authors.map((_author, index) => {

    let flag = (_author.canadian && window.sitesettings.store_info.country === "Canada");

    return (<span key={index}>{_author.name}{(flag && <span style={{ "paddingLeft": "2px" }}><CanadaIcon /></span>)}{(index !== _authors.length - 1) ? ", " : ""}</span>);
  });
}

export const parseAuthorsLink = (_authors, session) => {
  if (!_authors) { return "" }
  return _authors.map((_author, index) => {

    let flag = (_author.canadian && session?.is_canadian);

    return (<Tooltip mouseEnterDelay={1} placement="right" title={<small>View other titles by this author</small>}><a onClick={() => {
      if (session.has_bestsell) {
        window.open("/browse/filter/k/author/t/" + handleTermSlash(_author.name, true));
      } else {
        window.open("/browse/filter/v/date/k/author/t/" + handleTermSlash(_author.name, true));
      }
    }} key={index}>{_author.name}{(flag && <span style={{ "paddingLeft": "2px" }}><CanadaIcon /></span>)}{(index !== _authors.length - 1) ? ", " : ""}</a></Tooltip>);
  });
}

export const getPrice = (_available, _cond = false) => {



  if (!Array.isArray(_available)) {
    _available = [_available];
  }

  let _f;
  if (_cond !== false) {
    _f = (_available.find(item => item.code === _cond));
  } else {
    _f = lowestAvalPrice(_available);
  }
  if (_f) {
    return Number(_f.row_price) || 0;
  } else {
    return 0;
  }

}

const lowestAvalPrice = (_arr) => {
  let filtered = _arr.filter(item => parseFloat(item.row_price) > 0);
  if (filtered.length > 0) {
    filtered = filtered.sort((a, b) => parseFloat(a.row_price) - parseFloat(b.row_price));
    return filtered[0];
  } else {
    return { "row_price": 0 };
  }
}

export const getItemAlt = (_item) => {

  let _price = getPrice(_item?.available || []);
  let _binding = _item?.binding ? ` for the ${_item.binding}` : "";
  let _title = _item?.title ? ` of ${_item.title}` : "";
  let _by = (_item?.authors && Array.isArray(_item.authors) && _item.authors.length)
    ? ` by ${_item.authors.map(item => item.name).join(", ")}`
    : "";
  let _sellPrice = _price ? ` with sell price $${_price}` : "";

  return `Product cover image${_binding}${_title}${_by}${_sellPrice}.`;
};

export const parseURL = (_itm) => {

  if (_itm.type === "features") {
    return "/features";
  }

  let _searchObj = _itm.search;

  if (typeof _searchObj !== "object" || Array.isArray(_searchObj) || _searchObj === null) {
    return false;
  }

  let { status = [], subj1 = [], binding = [], pubdate = [], audience = [], search_type = "", search_term = "" } = _searchObj;

  const map = {
    b: status, // browse
    s: subj1.filter((cat) => { return cat.substr(0, 2) !== "__" }), // subjects
    n: subj1.filter((cat) => { return cat.substr(0, 2) === "__" }), // non-books
    d: pubdate, // date 
    f: binding, // format 
    a: audience, // age
    o: 0, // offset
    l: 26, // limit
    t: search_term, // term
    k: search_type, // type
  }
  return objToPath("/browse/filter", map);
}


export const initialFilters = {
  b: [], // browse
  s: [], // subjects
  n: [], // non-books
  d: [], // date 
  f: [], // format 
  a: [], // age
  o: 0, // offset
  l: 20, // limit
  t: "", // term
  k: "", // type
  v: "", // sort
  x: "",
  r: [], // stock (on hand, on order)
  c: [], // categories
  g: [], // language
  j: [], // secondary subject thing... 
};

export const imageFallback = (i, light = true) => {
  i.target.src = "https://cdn1.bookmanager.com/i/nocover.png"
  if (light) {
    i.target.className = "light ant-image-img";
  }
}



export const bmDate = (_date) => {
  return moment(_date).format("MMM DD-YY")
}

export const getFlag = (_country) => {
  let flag = "https://cdn1.bookmanager.com/i/CA.png"
  switch (_country) {
    case "Canada":
      flag = "CA"
      break;
    case "United Kingdom":
      flag = "CA"
      break;
    case "USA":
      flag = "US"
      break;
    default:
      flag = false
      break;
  }
  return (flag) ? <img src={"https://cdn1.bookmanager.com/i/" + flag + ".png"} /> : <></>
}

export const addCommas = (_num) => {
  return _num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatCount = (_count) => {
  _count = _count.toString()
  if (_count === "-1") { return ""; }
  if (_count.length > 3) { return _count.substring(0, _count.length - 3) + "k"; }
  return _count.toString()
}

export const objToPath = (_prefix, _obj) => {
  let location = _prefix;
  Object.keys(_obj).forEach((key) => {
    location += (Array.isArray(_obj[key]) && _obj[key].length > 0) ? "/" + key.toString() + "/" + _obj[key].join("/") : "";
  })
  //offset
  if (_obj.o !== 0) {
    location += "/o/" + _obj.o.toString();
  }
  //term
  if (_obj.t !== "") {
    location += "/t/" + encodeURI(_obj.t)
  }
  //key type
  if (_obj.k !== "") {
    location += "/k/" + encodeURI(_obj.k)
  }
  return location;
}

export const hasLink = (_s = "") => {
  return (!_s || _s === "" || _s === "/" || _s === "http://" || _s === "https://") ? false : true;
}

function isLetter(c) {
  return c.toLowerCase() != c.toUpperCase();
}



export const adjustOpacity = (hexCode, amount) => {
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${amount / 100})`;
};

export const adjustColor = (col, amt) => {

  var usePound = false;

  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00FF) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000FF) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);

}

export const extractValueFromUrl = (str) => {

  const index = str.indexOf("/list/");
  if (index === -1 || index >= str.length - 12) {
    return ""; // "/lists/" not found or not enough characters after it
  }
  return str.substr(index + 6, 12); // 7 is the length of "/lists/" string

}

export const filterUnique = (array, property) => {
  const seen = {};
  return array.reduce((uniqueArray, currentItem) => {
    const value = currentItem[property];
    if (!seen.hasOwnProperty(value)) {
      seen[value] = true;
      uniqueArray.push(currentItem);
    }
    return uniqueArray;
  }, []);
}

export function isLocalStorageAvailable() {
  var test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}


export const getListPrice = (list_price_can, list_price_usa, is_canadian, _br = false, _weight = 500) => {
  let _can = (list_price_can > 0) ? "$" + list_price_can : "";
  let _us = (list_price_usa > 0) ? "$" + list_price_usa : "";
  // Add suffix if both exist..
  if (_can && _us) {
    _can = _can + " CA";
    _us = _us + " US"
  }
  let _sep = (_can && _us) ? " / " : " ";

  if (_br) {
    _sep = "";
  }
  return (<div style={{ "fontWeight": _weight }}>{(is_canadian && (_can || _us)) ? <>{_can}{(_br && <br />)}{_sep}{_us}</> : <>{_us}{_sep}{_can}</>}<small> {((_can || _us) && <>{(_br) ? "" : "list price"}</>)}</small></div>)
}

export const pluralize = (count, noun, suffix = 's') => {
  return (count === 1) ? noun : noun + suffix;
}

export const makeKey = () => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);;
}


export function searchFields(_arr, _search, _fields) {
  if (!_search) return _arr;

  const search = _search.toLowerCase();

  return _arr
    .map(item => {
      const fieldIndex = _fields.findIndex(field => {
        const value = item[field];

        // regular field
        if (typeof value === "string") {
          return value.toLowerCase().includes(search);
        }

        // specialties
        if (Array.isArray(value)) {
          return value.some(v =>
            typeof v === "string" &&
            v.toLowerCase().includes(search)
          );
        }

        return false;
      });

      return fieldIndex === -1 ? null : { item, fieldIndex };
    })
    .filter(Boolean)
    .sort((a, b) => a.fieldIndex - b.fieldIndex)
    .map(({ item }) => item);
}

export const colorDate = (_timestamp, values) => {
  let now = moment().unix();
  let color = "inherit";
  if (_timestamp > now) {
    // future
    color = "futureColor";
  } else {
    // within the last two months
    if ((now - _timestamp) < 5274000) {
      // within the last two months
      color = "returnedColor";
    }
  }
  if (values?.highlight) {
    return color;
  }
  return color;
}



export const ucfirst = (string) => {

  if (string.includes("-")) {
    string = string.split("-");
    string = string.map(item => ucfirst(item));
    return string.join(" ");
  }

  if (string.includes("_")) {
    string = string.split("_");
    string = string.map(item => ucfirst(item));
    return string.join(" ");
  }

  return (string) ? string.charAt(0).toUpperCase() + string.slice(1) : "";
}

export const getMemory = (_key) => {
  let _saved = Cookies.get("memory");
  if (!_saved) return [];
  _saved = JSON.parse(_saved);
  if (_saved.hasOwnProperty(_key)) {
    return _saved[_key];
  } else {
    return []
  }
}

export const saveMemory = (_key, _value) => {
  let _saved = Cookies.get("memory");
  let memory = {}
  // no memory at all - save first
  if (!_saved) {
    memory = {
      [_key]: [_value]
    }
    Cookies.set("memory", JSON.stringify(memory))
    return memory[_key];
  }

  _saved = JSON.parse(_saved);
  // memory exists, no key 
  if (!_saved.hasOwnProperty(_key)) {
    _saved[_key] = [_value]
    Cookies.set("memory", JSON.stringify(_saved))
    return _saved[_key];
  }

  if (_saved[_key].includes(_value)) {
    // not unique, put it at the top
    _saved[_key] = _saved[_key].filter(item => item !== _value);
    _saved[_key].unshift(_value);
    Cookies.set("memory", JSON.stringify(_saved));
    return _saved[_key];
  }

  _saved[_key].unshift(_value);
  _saved[_key] = _saved[_key].slice(0, 6); // limit to 5
  Cookies.set("memory", JSON.stringify(_saved));
  return _saved[_key];

}

export const parseAuthorsPlain = (_authors) => {
  if (!_authors || _authors.length === 0) { return "" }
  return _authors.map((_author, index) => {
    return (<span key={index}>{_author.name}{(index !== _authors.length - 1) ? ", " : ""} </span>);
  });
}



export const parseSubjectsPlain = (_subjects) => {
  if (!_subjects || _subjects.length === 0) { return ""; }
  return _subjects.map((_subject, index) => {
    const labels = _subject?.labels?.map(label => label.trim()).filter(Boolean) || [];
    return (
      <span key={index}>
        {labels.join(" / ")}
        {index < _subjects.length - 1 && " "}
      </span>
    );
  });
};


export const parseSubjectsWeird = (_subjects, _limit = 30) => {
  if (!_subjects || _subjects.length === 0) { return ""; }
  const subject = _subjects[0];
  const labels = subject?.labels?.map(label => label.trim()).filter(Boolean) || [];
  if (labels.length > 1) {
    return (<>{subject?.bisac?.substr(0, 3)}: {labels[labels.length - 1]} </>);
  }
  return (<>{(labels[0] || "").substring(0, _limit)} </>);
};


export const parseSubjects = (subjects = []) => {
  const labels = new Set();

  subjects.forEach(subject => {
    subject?.labels?.forEach(label => {
      labels.add(label.trim());
    });
  });

  const unique = [...labels];
  let paths = parseSubjectsPaths(subjects);
  return (
    <>
      <Tooltip title={<small>{paths.map((item, index) => { return <div>{item}</div> })}</small>} key={"tip"}>
        {unique.map((label, index) => (
          <>
            {index === 0 ? <strong className="c">{label}</strong> : label}
            {index < unique.length - 1 && " / "}
          </>
        ))}
      </Tooltip>
    </>
  );
};


export const parseSubjectsPaths = (subjects = []) => {
  return subjects.map(subject => {
    return subject?.labels?.map(label => label.trim()).filter(Boolean).join(" / ")
  }).filter(Boolean);
};

export const parseSubjectsList = (_subjects) => {
  if (!_subjects || _subjects.length === 0) { return ""; }
  return _subjects.map((_subject, index) => {
    const labels = _subject?.labels?.map(label => label.trim()).filter(Boolean) || [];
    const [top, ...rest] = labels;
    return (
      <span key={index}>
        {top && <strong className="c">{top}</strong>}
        <br />
        {rest.map((label, i) => (<span key={i}> {label} <br /> </span>))}
      </span>
    );
  });
};


export const parseSubjectsBisacs = (_subjects) => {
  if (!_subjects || _subjects.length === 0) { return ""; }
  return _subjects.map((_subject, index) => {
    const labels = _subject?.labels?.map(label => label.trim()).filter(Boolean) || [];
    const [top, ...rest] = labels;
    return (
      <span key={index}>
        {top && <strong className="c">{top}</strong>}
        <br />
        {rest.map((label, i) => (
          <span key={i}> {label}{" "} <em> <small>{_subject.bisac}</small> </em> <br /> </span>
        ))}
      </span>
    );
  });
};



export const dateFormat = (date) => {

  return moment(date * 1000).format("MMMM D YYYY h:mma");
}

export const handleTermSlash = (_str, _encode = false) => {

  if (_encode) {
    _str = _str.replaceAll("?", "");
    return _str.replaceAll("/", "%2f");
  } else {
    return _str.replaceAll("%2f", "/");
  }

}

export const sortAlpha = (_arr, _key) => {
  return _arr.sort((a, b) => {
    let _a = a[_key].toLowerCase();
    let _b = b[_key].toLowerCase();
    if (_a < _b) {
      return -1; // nameA comes before nameB
    }
    if (_a > _b) {
      return 1; // nameA comes after nameB
    }
    return 0; // names are equal
  });
}

export const pathToObject = (_path, _save = "") => {


  let returnObject = {
    o: 0, // offset
    l: 26, // limit
    t: "", // term
    k: "", // type
    v: "", // order
    p: "", // preset
    z: "" // series
  }

  if (_save) {
    let _lm = parseInt(Cookies.get(_save));
    if (!isNaN(_lm)) {
      returnObject.l = _lm;
    }
  }

  let startIndex = _path.search(/filter/i);
  let p = _path.substr(startIndex, _path.length);
  let split = p.split("/");
  let key;
  let ka = ["b"];
  for (let i = 0; i < split.length; i++) {
    if (split[i].length === 1 && isLetter(split[i])) {
      key = split[i];
    } else {
      if (!returnObject.hasOwnProperty(key)) {
        if (key) {
          returnObject[key] = [];
        } else {
          continue;
        }
      }
      if (Array.isArray(returnObject[key])) {

        returnObject[key] = [...returnObject[key], split[i]];
      } else {
        if (key === "o" || key === "l") {

          returnObject[key] = parseInt(split[i]);
        } else {
          returnObject[key] = split[i];
        }
      }
      (ka.indexOf(key) === -1 && ka.push(key));
    }
  }

  return returnObject;
}



export const objectToPath = (_obj, firstpage = false) => {
  let location = "/filter";

  // remove sub-subjects if there is no top-level subject
  if (_obj.hasOwnProperty("c") && _obj.c.length === 0) {
    if (_obj.hasOwnProperty("d") && _obj.d.length > 0) {
      delete _obj.d;
    }
  }

  if (_obj.hasOwnProperty("c") && _obj.hasOwnProperty("d")) {
    for (let i = 0; i < _obj.d.length; i++) {
      // tobias (16apr2025): account for negation for web/issues#4445
      let test = _obj.d[i];
      if (test.startsWith("-")) {
        test = test.substr(1, 3);
      } else {
        test = test.substr(0, 3);
      }
      if (!_obj.c.includes(test)) {
        _obj.d = _obj.d.filter(itm => itm !== _obj.d[i]);
      }
    }
  }

  if (firstpage) {
    _obj.o = 0;
  }

  //(June 27, 2023) George - 
  //Created a loop with a couple checks to make the code more futureproof for new filters
  //Also differentiates between arrays and non-arrays for the different _obj values, to handle correctly

  Object.keys(_obj).forEach((key) => {
    //runs if value is an array to properly append all values to url
    if (Array.isArray(_obj[key]) && _obj[key].length > 0) {
      if (_obj[key].includes("AND") && _obj[key].length < 3) {
        // strip and
        _obj[key] = _obj[key].filter(itm => itm !== "AND");
      }
      location += "/" + key.toString() + "/" + _obj[key].join("/")
      //runs for non-array values, like limit and offset
    } else if (_obj.hasOwnProperty(key) && _obj[key]) {
      //checks to see if the value at key is a string for encoding purposes
      if (typeof _obj[key] !== "string") {
        //run when value is not a string, so it can be turned into one for the sake of the url
        //examples are limit or offset, which are numbers
        //specific if to make sure firstpage values aren't being added to the url
        if ((key === 'l' && _obj[key] !== 20) || (key === 'o' && _obj[key] !== 0)) {
          location += "/" + key.toString() + "/" + _obj[key].toString();
        }
      } else {
        //runs when it is a string, so it can be properly encoded
        //example would be filter x
        location += "/" + key.toString() + "/" + encodeURI(_obj[key]);
      }
    }
  })

  return location;
}


export function flattenArray(items, childKey) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.reduce((acc, item) => {
    acc.push(item);
    if (Array.isArray(item[childKey])) {
      acc.push(...item[childKey]);
    }
    return acc;
  }, []);
}
